import { Routes } from '@angular/router';

import { entraAdminGuard } from './core/auth/entra-admin.guard';
import { entraAuthGuard } from './core/auth/entra-auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePageComponent),
    title: 'MKZS.tech | Scalable Azure & .NET Solutions'
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about.page').then(m => m.AboutPageComponent),
    title: 'MKZS.tech | About'
  },
  {
    path: 'services',
    loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesPageComponent),
    title: 'MKZS.tech | Services'
  },
  {
    path: 'portfolio',
    loadComponent: () => import('./pages/portfolio/portfolio.page').then(m => m.PortfolioPageComponent),
    title: 'MKZS.tech | Portfolio'
  },
  {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.page').then(m => m.ContactPageComponent),
    title: 'MKZS.tech | Contact'
  },
  {
    path: 'account',
    loadComponent: () => import('./pages/account/account.page').then(m => m.AccountPageComponent),
    canActivate: [entraAuthGuard],
    title: 'MKZS.tech | Account'
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin.page').then(m => m.AdminPageComponent),
    canActivate: [entraAdminGuard],
    title: 'MKZS.tech | Admin'
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.page').then(m => m.PrivacyPageComponent),
    title: 'MKZS.tech | Privacy Policy'
  },
  {
    path: 'cookies',
    loadComponent: () => import('./pages/cookies/cookies.page').then(m => m.CookiesPageComponent),
    title: 'MKZS.tech | Cookie Policy'
  },
  {
    path: '**',
    loadComponent: () => import('./pages/not-found/not-found.page').then(m => m.NotFoundPageComponent),
    title: 'MKZS.tech | Page Not Found'
  }
];

